import { useLocation, useNavigate } from "react-router-dom";
import ShimmerSkeleton from "./components/shimmercomponents/ShimmerSkeleton";
import { useEffect } from "react";
import { applyAuthParams, hasToken } from "./utils/authToken";

const RootRedirect = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
    applyAuthParams(location.search);
    if (hasToken()) {
    navigate('/auditor/audit', { replace: true });
    } else {
    navigate('/auditor/auth/login', { replace: true });
    }
    }, [location.search, navigate]);

    return <ShimmerSkeleton/>;

    };

    export default RootRedirect;
